import { Component, ElementRef, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// ionic
import { Events } from '../../helpers/events';

// rxjs
import { Subject } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";

// components

// other libraries
import { TranslateService } from "@ngx-translate/core";

// providers
import { EventService } from "../../services/event.service";
import { StreamService } from "../../services/stream.service";
import { PlatformService } from "../../services/platform.service";
import { UserService } from "../../services/user.service";

// models
import { Event } from "../../models/event";
import { Stream } from "../../models/stream";
import { User } from "../../models/user";

@Component({
    selector: 'stream-detail',
    templateUrl: './stream-detail.component.html',
    styleUrls: ['./stream-detail.component.scss'],
})
export class StreamDetailComponent implements OnInit {

    /**
     * actual event
     *
     * @type Event
     */
    @Input() event: Event;

    /**
     * selected stream
     *
     * @type Stream
     */
    @Input() stream: Stream;

    /**
     * selected stream ID
     *
     * @type {number}
     */
    @Input() stream_id: number;

    /**
     * streamBox
     *
     * @type ViewChild
     */
    @ViewChild('streamBox') streamBox: ElementRef;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * current event
     *
     * @type {User}
     */
    public user: User;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    /**
     * initial loading state, we should have injected stream model by default
     *
     * @type {boolean}
     */
    public loading: boolean = false;

    constructor(
        public appEvents: Events,
        public userService: UserService,
        public eventService: EventService,
        public translate: TranslateService,
        public streamService: StreamService,
        public plt: PlatformService,
        public router: Router
    ) {
        this.userLang = this.translate.currentLang;
    }

    ngOnInit() {
        // subscribe to current user
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe(
            (user) => {
                this.user = user;

                // if stream is not injected
                if (!this.stream) {
                    // load it from service
                    this.loading = true
                    this.streamService.getById(+this.stream_id).subscribe(
                        (stream: Stream) => {
                            this.loading = false;
                            this.stream = new Stream(stream);
                        });
                }
            });
    }

    /**
     *load stream detail in messages page
     *
     * @param {Stream} stream
     *
     * @return void
     */
    public loadStream(stream: Stream) {
        // change the url to stop the running video
        this.stream.embed_link = this.stream.embed_link + '?1';

        // NOTE[jg] - used before, not needed now...
        // we need to redirect to messages page and trigger event for loading
        // setTimeout(() => {
        // this.appEvents.publish('messages:chatGroup', stream.chat_group);
        // }, 500);

        // change route
        setTimeout(() => {
            this.stream.embed_link = this.stream.initEmbedLink();
            // reset notification badge
            this.stream.unread_messages_count = 0;
            this.router.navigate([this.plt.defaultLink + '/messages/channel/' + stream.chat_group.id]);
        }, 0);

    }

}
